import { LOCATION_CHANGE } from 'react-router-redux';

import * as D from '../../deps';
import * as GoogleAnalyticsWorkers from '../workers';

export default [
  {
    actionType: LOCATION_CHANGE,
    handler: GoogleAnalyticsWorkers.onLocationChange,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.ViewActions.OPEN_SESSION_HISTORY,
    handler: GoogleAnalyticsWorkers.onOpenSessionHistory,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.ViewActions.CLOSE_SESSION_HISTORY,
    handler: GoogleAnalyticsWorkers.onCloseSessionHistory,
    concur: 'takeEvery',
  },
];
